import React from 'react'

function About() {
  return (
    <div id='about' className='container about'>
        <h4>Who am i<span>?</span></h4>
        <p>I am currently a software engineering intern at Software Technologies Limited focusing on fullstack web developement using Vue and Laravel. Previously, I worked as a Software Engineering Intern at Cytonn, Investments and Real Estate company focuing on frontend development using React.js, Vue.js SCSS and other CSS framworks like Tailwind, Boostrap and Foundation</p>
    </div>
  )
}

export default About